import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  CheckmarkCircleOutline,
  CloseCircleOutline,
  HourglassOutline,
} from "react-ionicons";

const ICONS = {
  success: {
    component: CheckmarkCircleOutline,
    color: "#00000",
    title: "Success",
    className: "text_master2",
  },
  pending: {
    component: HourglassOutline,
    color: "#DC3545",
    title: "Pending",
    className: "text-danger",
  },
  failed: {
    component: CloseCircleOutline,
    color: "#00000",
    title: "Sorry!",
    className: "text-danger",
  },
};

const PaymentStatusModal = ({ show, status = "failed", message, redirectUrl, onClose, sessionData }) => {
  const { component: Icon, color, title, className } = ICONS[status] || ICONS.failed;

  return (
    <Modal show={show} centered>
      <Modal.Body>
        <div className="text-center">
          <Icon color={color} height="50px" width="50px" className={className} />
          <div className={`font_24 fw_700 mb-2 ${className}`}>{title}</div>
          <div className="font_16 mb-3">{message}</div>
        </div>
        <div className="align-items-center d-flex gap-3 justify-content-center">
          {!sessionData?.redirect_from && (
            <button className="btn px_btn btn-master px-4 rounded fw_500 font_12" onClick={onClose}>
              Close
            </button>
          )}
          {sessionData?.redirect_from ? (
            <a
              className="btn px_btn btn-master px-4 rounded fw_500 font_12"
              onClick={() =>
                (window.location.href = `${sessionData?.redirect_from || redirectUrl}?payment_result=${status === "success" ? 1 : status === "pending" ? 2 : 0}&error=${message}`)
              }
            >
              Go to payment history
            </a>
          ) : (
            <Link to="/paymenthistory" className="btn px_btn btn-master px-4 rounded fw_500 font_12">
              Go to payment history
            </Link>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentStatusModal;
